import { MarkdownTextPrimitive } from "@assistant-ui/react-markdown";
import React from "react";

/**
 * Markdown renderer for assistant chat messages, styled to sit inside a chat bubble.
 * Pass as the Text component of `MessagePrimitive.Parts`.
 */
const ChatMarkdownText = () => {
  return (
    <MarkdownTextPrimitive
      className="break-words"
      components={{
        p: ({ node: _node, ...props }) => <p className="mb-2 last:mb-0" {...props} />,
        ul: ({ node: _node, ...props }) => (
          <ul className="mb-2 list-disc pl-5 last:mb-0" {...props} />
        ),
        ol: ({ node: _node, ...props }) => (
          <ol className="mb-2 list-decimal pl-5 last:mb-0" {...props} />
        ),
        li: ({ node: _node, ...props }) => <li className="mt-1 first:mt-0" {...props} />,
        a: ({ node: _node, ...props }) => (
          <a
            className="font-medium text-primary-700 underline hover:text-primary-800"
            target="_blank"
            rel="noreferrer"
            {...props}
          />
        ),
        strong: ({ node: _node, ...props }) => <strong className="font-semibold" {...props} />,
        h1: ({ node: _node, ...props }) => (
          <h1 className="mb-1 mt-3 text-[15px] font-semibold first:mt-0" {...props} />
        ),
        h2: ({ node: _node, ...props }) => (
          <h2 className="mb-1 mt-3 text-[15px] font-semibold first:mt-0" {...props} />
        ),
        h3: ({ node: _node, ...props }) => (
          <h3 className="mb-1 mt-3 font-semibold first:mt-0" {...props} />
        ),
        h4: ({ node: _node, ...props }) => (
          <h4 className="mb-1 mt-3 font-semibold first:mt-0" {...props} />
        ),
        blockquote: ({ node: _node, ...props }) => (
          <blockquote
            className="mb-2 border-l-2 border-neutral-300 pl-2 text-neutral-600"
            {...props}
          />
        ),
        code: ({ node: _node, ...props }) => (
          <code
            className="rounded bg-neutral-200 px-1 py-0.5 font-mono text-[12px] text-neutral-800"
            {...props}
          />
        ),
        pre: ({ node: _node, ...props }) => (
          <pre
            className="mb-2 overflow-x-auto rounded-md bg-neutral-800 p-2 font-mono text-[12px] text-white last:mb-0 [&_code]:bg-transparent [&_code]:p-0 [&_code]:text-white"
            {...props}
          />
        ),
        hr: ({ node: _node, ...props }) => <hr className="my-2 border-neutral-200" {...props} />,
      }}
    />
  );
};

export default ChatMarkdownText;
